import { buildProps, definePropType, mutable } from '@ll-plus/utils'

import HeaderSearch from '../components/header-search.vue'

import type { ExtractPropTypes } from 'vue'

// 头部menu的enum
export const enum ImenuSwitchType {
  TABLE = 'table',
  CARD = 'card'
}
// menuList
export const menuSwitchRadioList = [
  {
    value: ImenuSwitchType.TABLE,
    icon: 'icon-list'
  },
  {
    value: ImenuSwitchType.CARD,
    icon: 'icon-card'
  }
] as const

export interface IMenuSwitchOptions {
  show?: boolean // 是否显示切换菜单
  onChange?: (value: ImenuSwitchType) => void // 切换菜单的change
}

export const tableHeaderSearchProps = buildProps({
  headerSearchHeight: {
    type: Number,
    default: 36
  },
  menuSwitchOptions: {
    type: definePropType<IMenuSwitchOptions>(Object),
    default: () => mutable({} as const)
  }
} as const)

export const tableHeaderSearchEmits = {
  change: (v: ImenuSwitchType) => !!v, // 返回值要明确返回一个布尔类型要不然vue会警告
  changeHeaderSearch: (height: number) => !!height // 返回值要明确返回一个布尔类型要不然vue会警告
}

// props
export type TableHeaderSearchProps = ExtractPropTypes<
  typeof tableHeaderSearchProps
>

// emits
export type TableHeaderSearchEmits = typeof tableHeaderSearchEmits

// instance
export type TableHeaderSearchInstance = InstanceType<typeof HeaderSearch>
